import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#F7E900',
      darker: '#053e85',
      contrastText: '#000000',
    },
    neutral: {
      main: '#64748B',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000', 
        },
      },
    },
  },
});

export default theme;
